import E, { createContext as v, useRef as y, useState as b, useMemo as m, useEffect as C, useContext as F, useSyncExternalStore as k } from "react";
import { WidgetCtx as T } from "@opencx/widget-core";
import { v4 as W } from "uuid";
const O = "4.0.45";
class P {
  constructor(t) {
    this.components = [];
    const { components: n } = t;
    if (n && n.forEach((o) => this.register(o)), this.components.length === 0)
      throw new Error("No components registered");
    if (!this.get("fallback"))
      throw new Error("No fallback component registered");
  }
  // TODO test that this registers or replaces the component
  register(t) {
    const n = this.components.findIndex((o) => o.key === t.key);
    return n !== -1 ? this.components[n] = t : this.components.push(t), this;
  }
  get(t) {
    const n = this.components.find(
      (o) => o.key.toUpperCase() === t.toUpperCase()
    );
    return n || null;
  }
  getComponent(t) {
    var n;
    return (n = this.get(t)) == null ? void 0 : n.component;
  }
}
const U = v(null);
function B({
  options: e,
  children: t,
  components: n,
  storage: o,
  loadingComponent: a
}) {
  const i = y(null), l = y(!1), [u, g] = b(null), c = m(
    () => new P({
      components: n
    }),
    [n]
  );
  return C(() => {
    l.current || (l.current = !0, T.initialize({ config: e, storage: o }).then(g).catch(console.error));
  }, []), u ? /* @__PURE__ */ E.createElement(
    U.Provider,
    {
      value: {
        widgetCtx: u,
        config: e,
        components: n,
        componentStore: c,
        version: O,
        contentIframeRef: i
      }
    },
    t
  ) : a || null;
}
function f() {
  const e = F(U);
  if (!e)
    throw new Error("useWidget must be used within a WidgetProvider");
  return e;
}
function x() {
  const { config: e } = f();
  return e;
}
function w(e) {
  return k(e.subscribe, e.get, e.get);
}
function D() {
  const { widgetCtx: e } = f();
  return {
    contactState: w(e.contactCtx.state),
    createUnverifiedContact: e.contactCtx.createUnverifiedContact
  };
}
function I() {
  const [e, t] = b("ltr");
  return C(() => {
    const n = () => {
      typeof document > "u" || t(
        window.getComputedStyle((window.top || window).document.body).direction
      );
    };
    n();
    const o = new MutationObserver(n);
    return o.observe(document.documentElement, {
      attributes: !0,
      attributeFilter: ["dir"]
    }), o.observe(document.body, {
      attributes: !0,
      attributeFilter: ["dir"]
    }), window.addEventListener("languagechange", n), () => {
      o.disconnect(), window.removeEventListener("languagechange", n);
    };
  }, []), { dir: e };
}
function R() {
  const { widgetCtx: e } = f();
  return { messagesState: w(e.messageCtx.state), sendMessage: e.messageCtx.sendMessage };
}
function A() {
  const { widgetCtx: e } = f(), { oneOpenSessionAllowed: t } = x(), n = w(e.sessionCtx.sessionState), o = w(e.sessionCtx.sessionsState), { openSessions: a, closedSessions: i } = m(() => ({
    openSessions: o.data.filter((u) => u.isOpened === !0),
    closedSessions: o.data.filter((u) => u.isOpened === !1)
  }), [o.data]), l = m(() => t ? a.length === 0 : !0, [t, a.length]);
  return {
    sessionState: n,
    sessionsState: o,
    loadMoreSessions: e.sessionCtx.loadMoreSessions,
    resolveSession: e.sessionCtx.resolveSession,
    createStateCheckpoint: e.sessionCtx.createStateCheckpoint,
    openSessions: a,
    closedSessions: i,
    canCreateNewSession: l
  };
}
function z() {
  var i, l, u;
  const { sessionState: e } = A(), { messagesState: t } = R(), n = ((i = e.session) == null ? void 0 : i.assignee.kind) === "ai", o = ((u = (l = t.messages) == null ? void 0 : l.at(-1)) == null ? void 0 : u.type) === "USER";
  return { isAwaitingBotReply: !!(t.isSendingMessageToAI || (n || e.isCreatingSession) && (t.isSendingMessage || o)) };
}
function Y() {
  const { widgetCtx: e } = f();
  return {
    routerState: w(e.routerCtx.state),
    toSessionsScreen: e.routerCtx.toSessionsScreen,
    toChatScreen: e.routerCtx.toChatScreen
  };
}
const p = /* @__PURE__ */ new Map();
function _() {
  const [e, t] = b([]), {
    widgetCtx: { api: n }
  } = f();
  function o(s) {
    const r = s.map((d) => ({
      file: d,
      id: W(),
      status: "pending",
      progress: 0
    }));
    t((d) => [...d, ...r]), r.forEach(l);
  }
  function a(s, r) {
    t(
      (d) => d.map((S) => S.id === s ? { ...S, ...r } : S)
    );
  }
  function i(s) {
    t((r) => r.filter((d) => d.id !== s));
  }
  const l = async (s) => {
    const r = new AbortController();
    p.set(s.id, r);
    try {
      t(
        (S) => S.map(
          (h) => h.id === s.id ? { ...h, status: "uploading", progress: 0 } : h
        )
      );
      const d = await n.uploadFile({
        file: s.file,
        abortSignal: r.signal,
        onProgress: (S) => {
          a(s.id, { progress: S });
        }
      });
      a(s.id, {
        status: "success",
        fileUrl: d.fileUrl,
        progress: 100
      });
    } catch (d) {
      r.signal.aborted || a(s.id, {
        status: "error",
        error: d instanceof Error ? d.message : "Upload failed",
        progress: 0
      });
    } finally {
      p.delete(s.id);
    }
  }, u = (s) => {
    const r = p.get(s);
    r && (r.abort(), p.delete(s)), i(s);
  }, g = m(() => e.filter((s) => s.status === "success" && s.fileUrl), [e]);
  function c() {
    p.forEach((s) => s.abort()), p.clear(), t([]);
  }
  return C(() => () => {
    p.forEach((s) => s.abort()), p.clear();
  }, []), {
    allFiles: e,
    appendFiles: o,
    handleCancelUpload: u,
    successFiles: g,
    emptyTheFiles: c,
    getFileById: (s) => e.find((r) => r.id === s),
    getUploadProgress: (s) => {
      var r;
      return ((r = e.find((d) => d.id === s)) == null ? void 0 : r.progress) ?? 0;
    },
    getUploadStatus: (s) => {
      var r;
      return (r = e.find((d) => d.id === s)) == null ? void 0 : r.status;
    },
    hasErrors: e.some((s) => s.status === "error"),
    isUploading: e.some((s) => s.status === "uploading")
  };
}
const M = v(null);
function $({ children: e }) {
  const t = x(), [n, o] = b(() => t.inline ? !0 : t.isOpen ?? !1);
  return C(() => {
    o((a) => t.isOpen ?? a);
  }, [t.isOpen]), C(() => {
    const a = t.openAfterNSeconds;
    if (typeof a != "number" || isNaN(a))
      return;
    const i = setTimeout(() => o(!0), a * 1e3);
    return () => clearTimeout(i);
  }, [t.openAfterNSeconds]), /* @__PURE__ */ E.createElement(M.Provider, { value: { isOpen: n, setIsOpen: o } }, e);
}
function j() {
  const e = F(M);
  if (!e)
    throw new Error(
      "useWidgetTrigger must be used within a WidgetTriggerProvider"
    );
  return e;
}
function G() {
  var u, g;
  const { widgetCtx: e } = f(), { modesComponents: t } = x(), { sessionState: n } = A(), o = e.modes, a = (u = n.session) == null ? void 0 : u.modeId, i = o.find((c) => c.id === a), l = (g = t == null ? void 0 : t.find(
    (c) => {
      var s, r;
      return [
        (i == null ? void 0 : i.id) || "",
        ((s = i == null ? void 0 : i.name) == null ? void 0 : s.toLowerCase()) || "",
        ((r = i == null ? void 0 : i.slug) == null ? void 0 : r.toLowerCase()) || ""
      ].includes(c.key.toLowerCase());
    }
  )) == null ? void 0 : g.component;
  return {
    modes: o,
    modesComponents: t,
    activeModeId: a,
    activeMode: i,
    Component: l
  };
}
function H() {
  const { widgetCtx: e } = f(), {
    messagesState: { messages: t }
  } = R(), {
    csatRequestedMessage: n,
    isCsatRequested: o,
    csatSubmittedMessage: a,
    isCsatSubmitted: i,
    submittedScore: l,
    submittedFeedback: u
  } = m(() => {
    const g = t.find(
      (s) => s.type === "SYSTEM" && s.subtype === "csat_requested"
    ), c = t.findLast(
      (s) => s.type === "SYSTEM" && s.subtype === "csat_submitted"
    );
    return {
      csatRequestedMessage: g,
      isCsatRequested: !!g && !c,
      csatSubmittedMessage: c,
      isCsatSubmitted: !!c,
      submittedScore: c == null ? void 0 : c.data.payload.score,
      submittedFeedback: c == null ? void 0 : c.data.payload.feedback
    };
  }, [t]);
  return {
    submitCsat: e.csatCtx.submitCsat,
    csatRequestedMessage: n,
    isCsatRequested: o,
    csatSubmittedMessage: a,
    isCsatSubmitted: i,
    submittedScore: l,
    submittedFeedback: u
  };
}
export {
  B as WidgetProvider,
  $ as WidgetTriggerProvider,
  x as useConfig,
  D as useContact,
  H as useCsat,
  I as useDocumentDir,
  z as useIsAwaitingBotReply,
  R as useMessages,
  G as useModes,
  w as usePrimitiveState,
  A as useSessions,
  _ as useUploadFiles,
  f as useWidget,
  Y as useWidgetRouter,
  j as useWidgetTrigger
};
//# sourceMappingURL=index.js.map
